import React from 'react';
import { AGENCIES_PAGE_SIZE } from '../../../../utils/constants/agencies';
import {
  SkeletonCard,
  SkeletonDescription,
  SkeletonDescriptionLine,
  SkeletonLogo,
  SkeletonOffersCount,
  SkeletonPhone,
  SkeletonRow,
  SkeletonTitle
} from './styled';

export const AgencyCardSkeleton: React.FC = () => (
  <SkeletonCard data-cy="agency-skeleton">
    <SkeletonRow>
      <SkeletonLogo />
      <div>
        <SkeletonTitle />
        <SkeletonOffersCount />
      </div>
    </SkeletonRow>
    <SkeletonDescription />
    <SkeletonDescriptionLine />
    <SkeletonPhone />
  </SkeletonCard>
);

interface AgencyCardsSkeletonProps {
  count?: number;
}

export const AgencyCardsSkeleton: React.FC<AgencyCardsSkeletonProps> = ({
  count = AGENCIES_PAGE_SIZE
}) => (
  <>
    {Array.from({ length: count }, (_, index) => (
      <AgencyCardSkeleton key={index} />
    ))}
  </>
);
